import { module } from 'modujs';
import Emitter from "tiny-emitter/instance";

export default class extends module {
    constructor(m) {
        super(m);
        this.el.addEventListener( 'click', () => {
            this.open = document.querySelector( '[data-module-edit-form-target-open="' + this.el.dataset.moduleEditForm+ '"]');
            this.form = document.querySelector( '[data-module-edit-form-target="' + this.el.dataset.moduleEditForm+ '"]');
            this.formData = JSON.parse( this.el.dataset.formData );
            for( let key in this.formData ){
                if( this.formData.hasOwnProperty( key ) ){
                    let formElement = this.form.querySelector( '[name="' + key + '"]' );
                    if( formElement ){
                        if( formElement.tagName === 'INPUT' || formElement.tagName === 'hidden' ) {
                            if( formElement.type === 'checkbox' ){
                                formElement.checked = this.formData[ key ];
                                formElement.dispatchEvent( new Event('input', { bubbles: true, cancelable: true, }));
                            } else {
                                formElement.value = this.formData[ key ]
                            }
                        } else if( formElement.tagName === 'SELECT' ){
                            formElement.dispatchEvent( new CustomEvent( 'update', { detail: { value: this.formData[ key ] } } ) );
                        }
                    }
                }
            }
            this.open.click();
        });
    }
    init() {}
    destroy(){}
}
